import { BaseAction } from '../../store/actions';
import {
  JobPayload,
  Job,
  Operation,
  ReassignJobPayload,
  JobPhase,
  LoadJobsParams,
  SearchJobsParams,
} from '../../shared/models/jobs';

export enum JobsActions {
  CreateJob = '[Job] Create Job',
  CreateJobSuccess = '[Job] Create Job Success',
  CreateJobError = '[Job] Create Job Error',

  UpdateJob = '[Job] Update Job',
  UpdateJobSuccess = '[Job] Update Job Success',
  UpdateJobError = '[Job] Update Job Error',

  ResetUpdateJobState = '[Job] Reset Update Job State',

  StartJobsPoll = '[Job] Start Jobs Poll',
  StopJobsPoll = '[Job] Stop Jobs Poll',

  LoadJobs = '[Job] Load Jobs',
  LoadJobsSuccess = '[Job] Load Jobs Success',
  LoadJobsError = '[Job] Load Jobs Error',

  LoadJob = '[Job] Load Job',
  LoadJobSuccess = '[Job] Load Job Success',
  LoadJobError = '[Job] Load Job Error',

  StartJob = '[Job] Start Job',
  StartJobSuccess = '[Job] Start Job Success',
  StartJobError = '[Job] Start Job Error',

  CompleteJob = '[Job] Complete Job',
  CompleteJobSuccess = '[Job] Complete Job Success',
  CompleteJobError = '[Job] Complete Job Error',

  UpdateJobPhase = '[Job] Update Job Phase',
  UpdateJobPhaseSuccess = '[Job] Update Job Phase Success',
  UpdateJobPhaseError = '[Job] Update Job Phase Error',

  RemoveJob = '[Job] Remove Job',
  RemoveJobSuccess = '[Job] Remove Job Success',
  RemoveJobError = '[Job] Remove Job Error',

  ReassignJob  = '[Job] Reassign Job',
  ReassignJobSuccess  = '[Job] Reassign Job Success',
  ReassignJobError  = '[Job] Reassign Job Error',

  CancelJob = '[Job] Cancel Job',
  CancelJobSuccess = '[Job] Cancel Job Success',
  CancelJobError = '[Job] Cancel Job Error',

  SearchJobs = '[Job] Search Jobs',
  SearchJobsSuccess = '[Job] Search Jobs Success',
  SearchJobsError = '[Job] Search Jobs Error',

  StartJobsPollingAfterJobCreation = '[Job] Search Jobs After Start',
  StartSearchJobsPolling = '[Job] Start Search Jobs Polling',
  StopSearchJobsPolling = '[Job] Stop Search Jobs Success Polling',

  LoadSessionInfoForTasks = '[Job] Load Session Info For Tasks',
  LoadSessionInfoForTasksSuccess = '[Job] Load Session Info For Tasks Success',
  LoadSessionInfoForTasksError = '[Job] Load Session Info For Tasks Error',

  LoadFeedbacks = '[Job] Load Tasks Feedbacks',
  LoadFeedbacksSuccess = '[Job] Load Tasks Feedbacks Success',
  LoadFeedbacksError = '[Job] Load Tasks Feedbacks Error',
}

export class CreateJob implements BaseAction<JobsActions> {
  readonly type = JobsActions.CreateJob;

  constructor(public readonly payload: {
    orgId: number,
    body: JobPayload,
    includeChildren: boolean
  }) {}
}

export class CreateJobSuccess implements BaseAction<JobsActions> {
  readonly type = JobsActions.CreateJobSuccess;

  constructor(public readonly payload: Job) {}
}

export class CreateJobError implements BaseAction<JobsActions> {
  readonly type = JobsActions.CreateJobError;

  constructor(public readonly payload: string) {}
}

export class UpdateJob implements BaseAction<JobsActions> {
  readonly type = JobsActions.UpdateJob;

  constructor(public readonly jobID: number, public readonly body: JobPayload) {}
}

export class UpdateJobSuccess implements BaseAction<JobsActions> {
  readonly type = JobsActions.UpdateJobSuccess;
}

export class UpdateJobError implements BaseAction<JobsActions> {
  readonly type = JobsActions.UpdateJobError;

  constructor(public readonly payload: string) {}
}

export class ResetUpdateJobState implements BaseAction<JobsActions> {
  readonly type = JobsActions.ResetUpdateJobState;
}

export class StartJobsPoll implements BaseAction<JobsActions>{
  readonly type = JobsActions.StartJobsPoll;

  constructor(public readonly orgID: number, public readonly params: LoadJobsParams) {}
}

export class StopJobsPoll implements BaseAction<JobsActions>{
  readonly type = JobsActions.StopJobsPoll;
}


export class LoadJobs implements BaseAction<JobsActions> {
  readonly type = JobsActions.LoadJobs;

  constructor(public readonly orgID: number, public readonly params: LoadJobsParams) {}
}

export class LoadJobsSuccess implements BaseAction<JobsActions> {
  readonly type = JobsActions.LoadJobsSuccess;

  constructor(public readonly payload: Job[]) {}
}

export class LoadJobsError implements BaseAction<JobsActions> {
  readonly type = JobsActions.LoadJobsError;

  constructor(public readonly payload: string) {}
}

export class LoadJob implements BaseAction<JobsActions> {
  readonly type = JobsActions.LoadJob;

  constructor(public readonly id: number) {}
}

export class LoadJobSuccess implements BaseAction<JobsActions> {
  readonly type = JobsActions.LoadJobSuccess;

  constructor(public readonly payload: Job) {}
}

export class LoadJobError implements BaseAction<JobsActions> {
  readonly type = JobsActions.LoadJobError;

  constructor(public readonly payload: string) {}
}

export class StartJob implements BaseAction<JobsActions> {
  readonly type = JobsActions.StartJob;

  constructor(public readonly payload: {
    id: number,
    includeChildren: boolean
  }) {}
}

export class StartJobSuccess implements BaseAction<JobsActions> {
  readonly type = JobsActions.StartJobSuccess;

  constructor(public readonly payload: Operation & {org_id: number}) {}
}

export class StartJobError implements BaseAction<JobsActions> {
  readonly type = JobsActions.StartJobError;

  constructor(public readonly payload: string) {}
}

export class CompleteJob implements BaseAction<JobsActions> {
  readonly type = JobsActions.CompleteJob;

  constructor(public readonly id: number) {}
}

export class CompleteJobSuccess implements BaseAction<JobsActions> {
  readonly type = JobsActions.CompleteJobSuccess;

  constructor(public readonly payload: number) {}
}

export class CompleteJobError implements BaseAction<JobsActions> {
  readonly type = JobsActions.CompleteJobError;

  constructor(public readonly payload: string) {}
}

export class UpdateJobPhase implements BaseAction<JobsActions> {
  readonly type = JobsActions.UpdateJobPhase;

  constructor(public readonly id: number, public readonly phase: JobPhase) {}
}

export class UpdateJobPhaseSuccess implements BaseAction<JobsActions> {
  readonly type = JobsActions.UpdateJobPhaseSuccess;
}

export class UpdateJobPhaseError implements BaseAction<JobsActions> {
  readonly type = JobsActions.UpdateJobPhaseError;

  constructor(public readonly payload: string) {}
}

export class RemoveJob implements BaseAction<JobsActions> {
  readonly type = JobsActions.RemoveJob;

  constructor(public readonly id: number) {}
}

export class RemoveJobSuccess implements BaseAction<JobsActions> {
  readonly type = JobsActions.RemoveJobSuccess;

  constructor(public readonly payload: number) {}
}

export class RemoveJobError implements BaseAction<JobsActions> {
  readonly type = JobsActions.RemoveJobError;

  constructor(public readonly payload: string) {}
}

export class ReassignJob implements BaseAction<JobsActions> {
  readonly type = JobsActions.ReassignJob;

  constructor(public readonly jobID: number, public readonly body: ReassignJobPayload) {}
}

export class ReassignJobSuccess implements BaseAction<JobsActions> {
  readonly type = JobsActions.ReassignJobSuccess;

  constructor(public readonly payload: Job) {}
}

export class ReassignJobError implements BaseAction<JobsActions> {
  readonly type = JobsActions.ReassignJobError;

  constructor(public readonly payload: string) {}
}

export class CancelJob implements BaseAction<JobsActions> {
  readonly type = JobsActions.CancelJob;

  constructor(public readonly id: number) {}
}

export class CancelJobSuccess implements BaseAction<JobsActions> {
  readonly type = JobsActions.CancelJobSuccess;

  constructor(public readonly payload: number) {}
}

export class CancelJobError implements BaseAction<JobsActions> {
  readonly type = JobsActions.CancelJobError;

  constructor(public readonly payload: string) {}
}

export class SearchJobs implements BaseAction<JobsActions> {
  readonly type = JobsActions.SearchJobs;

  constructor(public readonly orgID: number, public readonly params: SearchJobsParams) {}
}

export class StartJobsPollingAfterJobCreation implements BaseAction<JobsActions> {
  readonly type = JobsActions.StartJobsPollingAfterJobCreation;

  constructor(public readonly orgID: number, public readonly params: SearchJobsParams) {}
}

export class SearchJobsSuccess implements BaseAction<JobsActions> {
  readonly type = JobsActions.SearchJobsSuccess;

  constructor(public readonly payload: {
    results: Job[];
    params: SearchJobsParams;
    search_after: string;
    total_hits: number;
  }) {}
}

export class SearchJobsError implements BaseAction<JobsActions> {
  readonly type = JobsActions.SearchJobsError;

  constructor(public readonly payload: string) {}
}

export class StartSearchJobsPolling implements BaseAction<JobsActions>{
  readonly type = JobsActions.StartSearchJobsPolling;

  constructor(public readonly orgID: number, public readonly params: SearchJobsParams) {}
}

export class StopSearchJobsPolling implements BaseAction<JobsActions>{
  readonly type = JobsActions.StopSearchJobsPolling;
}

export class LoadSessionInfoForTasks implements BaseAction<JobsActions> {
  readonly type = JobsActions.LoadSessionInfoForTasks;

  constructor(public readonly payload: number[]) {}
}

export class LoadSessionInfoForTasksSuccess implements BaseAction<JobsActions> {
  readonly type = JobsActions.LoadSessionInfoForTasksSuccess;

  constructor(public readonly payload: any[]) {}
}

export class LoadSessionInfoForTasksError implements BaseAction<JobsActions> {
  readonly type = JobsActions.LoadSessionInfoForTasksError;

  constructor(public readonly payload: string) {}
}

export class LoadFeedbacks implements BaseAction<JobsActions> {
  readonly type = JobsActions.LoadFeedbacks;

  constructor(public readonly payload: number[]) {}
}

export class LoadFeedbacksSuccess implements BaseAction<JobsActions> {
  readonly type = JobsActions.LoadFeedbacksSuccess;

  constructor(public readonly payload: any[]) {}
}

export class LoadFeedbacksError implements BaseAction<JobsActions> {
  readonly type = JobsActions.LoadFeedbacksError;

  constructor(public readonly payload: string) {}
}

export type JobAction = CreateJob | CreateJobSuccess | CreateJobError |
  UpdateJob | UpdateJobSuccess | UpdateJobError |
  LoadJobs | LoadJobsSuccess | LoadJobsError |
  LoadJob | LoadJobSuccess | LoadJobError |
  StartJob | StartJobSuccess | StartJobError |
  CompleteJob | CompleteJobSuccess | CompleteJobError |
  UpdateJobPhase | UpdateJobPhaseSuccess | UpdateJobPhaseError |
  RemoveJob | RemoveJobSuccess | RemoveJobError |
  ReassignJob | ReassignJobSuccess | ReassignJobError |
  ResetUpdateJobState | StartJobsPoll | StopJobsPoll |
  CancelJob | CancelJobSuccess | CancelJobError |
  SearchJobs | SearchJobsSuccess | SearchJobsError | 
  StartSearchJobsPolling | StopSearchJobsPolling | StartJobsPollingAfterJobCreation |
  LoadSessionInfoForTasks | LoadSessionInfoForTasksSuccess | LoadSessionInfoForTasksError |
  LoadFeedbacks | LoadFeedbacksSuccess | LoadFeedbacksError;
